
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contrato/politica-de-compliance",
      function () {
        return require("private-next-pages/contrato/politica-de-compliance/index.js");
      }
    ]);
  